import { useState, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import Badge from '@material-ui/core/Badge';
import NotificationBell from '@icon/NotificationBell';
import { useSelectorToStore } from '@hooks/reduxHooks';
import Dynamic from '@base/Dynamic/Dynamic';
import { BgColors, TextColors } from '@styles/index';

const RenderNotifications = Dynamic(() => import('./RenderNotifications'));

const StyledBadge = styled(Badge)`
  grid-column: 19/20;
  align-self: center;
  cursor: pointer;

  &.MuiBadge-root .MuiBadge-badge {
    width: max-content;
    padding-top: 3px;
    display: table;
    background-color: ${BgColors.GREEN};
    color: ${TextColors.WHITE};
    position: absolute;
    right: 12px;
    font-weight: bold;
  }
  @media (max-width: 70.95em) {
    grid-column: 17/18;
  }
  @media (max-width: 47.95em) {
    display: none;
  }
`;

const HeaderNotification = () => {
  const theme = useContext(ThemeContext);
  const props = useSelectorToStore(({ notifications }) => {
    return { notifications };
  });

  const { notifications } = props;
  const { results } = notifications;
  const unseenNewNotificationsCount = results
    .slice(0, 10)
    .filter((item) => !item.rat && item.section === 'new').length;
  const [anchorEl, setAnchorEl] = useState(null);
  const handleBellOnClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  return (
    <>
      <StyledBadge
        badgeContent={unseenNewNotificationsCount}
        onClick={handleBellOnClick}
      >
        <NotificationBell size="24px" color={theme.colors.fontGrey} />
      </StyledBadge>

      {anchorEl && (
        <RenderNotifications
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          results={results}
          theme={theme}
        />
      )}
    </>
  );
};

HeaderNotification.propTypes = {
  notifications: PropTypes.objectOf(PropTypes.any),
  results: PropTypes.arrayOf(PropTypes.any)
};

HeaderNotification.defaultProps = {
  notifications: {},
  results: []
};

export default HeaderNotification;
